export function stringify(param) {
    if (typeof (param) !== 'object') return '';

    let paramStr = '';
    for (let i in param) paramStr += `&${i}=${param[i]}`;
    paramStr = paramStr.slice(1);

    return paramStr;
}